import React from 'react';
import { MoreMenuGroup } from './MoreMenuGroup/MoreMenuGroup.tsx';
import { MoreMenuItem } from './MoreMenuItem/MoreMenuItem.tsx';
import { SocialLinks } from './SocialLinks/SocialLinks.tsx';
import styles from './MorePage.module.scss';
import IconSettings from '@static/images/icon_settings.svg';
import IconLanguage from '@static/images/icon_language.svg';
import IconBook from '@static/images/icon_book.svg';
import IconQuestionMark from '@static/images/icon_question_mark.svg';
import IconLogoWhite from '@static/images/logo_white.svg';
import IconPlayerHub from '@static/images/icon_player_hub.svg';
import IconBlog from '@static/images/icon_blog.svg';
import IconSuggestions from '@static/images/icon_chat.svg';
import IconInfo from '@static/images/icon_info.svg';
import IconCareers from '@static/images/icon_careers.svg';
import IconPrivacy from '@static/images/icon_privacy.svg';
import { ScrollFadeContainer } from '@colonist/ui';
export const MorePage = ({ showCareersNotification, onPatchNotesClick, onLanguageClick, onRulebookClick, isFaqExternal, onFaqClick, onChampionshipClick, onSuggestionsClick, onPlayerHubClick, onBlogClick, onAboutClick, onCareersClick, onPrivacyClick, liveStats, language, versionNumber })=>{
    return /*#__PURE__*/ React.createElement(ScrollFadeContainer, {
        direction: "vertical"
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.content
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.leftColumn
    }, /*#__PURE__*/ React.createElement(MoreMenuGroup, {
        headerText: {
            key: 'strings:morePage.game.title'
        }
    }, /*#__PURE__*/ React.createElement(MoreMenuItem, {
        icon: IconSettings,
        label: {
            key: 'strings:morePage.game.patchNotes'
        },
        onClick: onPatchNotesClick,
        rightText: `v${versionNumber.toString()}`
    }), /*#__PURE__*/ React.createElement(MoreMenuItem, {
        icon: IconLanguage,
        label: {
            key: 'strings:morePage.game.language'
        },
        onClick: onLanguageClick,
        rightText: language.toUpperCase()
    }), /*#__PURE__*/ React.createElement(MoreMenuItem, {
        icon: IconBook,
        label: {
            key: 'strings:homePage.header.rules'
        },
        onClick: onRulebookClick
    }), /*#__PURE__*/ React.createElement(MoreMenuItem, {
        icon: IconQuestionMark,
        label: {
            key: 'strings:homePage.footer.faq'
        },
        onClick: onFaqClick,
        isExternalLink: isFaqExternal
    })), /*#__PURE__*/ React.createElement(MoreMenuGroup, {
        headerText: {
            key: 'strings:morePage.community.title'
        }
    }, /*#__PURE__*/ React.createElement(MoreMenuItem, {
        icon: IconLogoWhite,
        label: {
            key: 'strings:morePage.community.championship26'
        },
        onClick: onChampionshipClick
    }), /*#__PURE__*/ React.createElement(MoreMenuItem, {
        icon: IconSuggestions,
        label: {
            key: 'strings:morePage.community.suggestions'
        },
        onClick: onSuggestionsClick,
        isExternalLink: true
    }), /*#__PURE__*/ React.createElement(MoreMenuItem, {
        icon: IconPlayerHub,
        label: {
            key: 'strings:morePage.community.playerHub'
        },
        onClick: onPlayerHubClick
    }), /*#__PURE__*/ React.createElement(MoreMenuItem, {
        icon: IconBlog,
        label: {
            key: 'strings:morePage.community.blog'
        },
        onClick: onBlogClick,
        isExternalLink: true
    })), /*#__PURE__*/ React.createElement(MoreMenuGroup, {
        headerText: {
            key: 'strings:morePage.company.title'
        }
    }, /*#__PURE__*/ React.createElement(MoreMenuItem, {
        icon: IconInfo,
        label: {
            key: 'strings:morePage.company.about'
        },
        onClick: onAboutClick
    }), /*#__PURE__*/ React.createElement(MoreMenuItem, {
        icon: IconCareers,
        label: {
            key: 'strings:morePage.company.careers'
        },
        onClick: onCareersClick,
        showNotificationIcon: showCareersNotification
    }), /*#__PURE__*/ React.createElement(MoreMenuItem, {
        icon: IconPrivacy,
        label: {
            key: 'strings:morePage.company.privacy'
        },
        onClick: onPrivacyClick
    }))), /*#__PURE__*/ React.createElement("div", {
        className: styles.rightColumn
    }, /*#__PURE__*/ React.createElement(SocialLinks, null), liveStats)));
};
